import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButton, MatButtonModule } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatCardModule } from '@angular/material/card'
import { MatIcon } from '@angular/material/icon'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatExpansionModule } from '@angular/material/expansion'
import { MatInput } from '@angular/material/input'
// import { MatOption } from '@angular/material/core'
// import { MatSelect } from '@angular/material/select'
import { MatDividerModule } from '@angular/material/divider'
import { NgxMaskDirective } from 'ngx-mask'
import { SnackbarCustomService } from '../../../../shared/components/snackbar/snackbar-custom.service'
// import { IndividualClientService } from '../../../../core/services/customer/individual-client/individual-client.service'
// import { LegalEntityClientService } from '../../../../core/services/customer/legal-entity-client/legal-entity-client.service'
// import { ConsultantClientCreateComponent } from '../../consultant-client-create/consultant-client-create.component'
import { BankDetailsClientCreateComponent } from '../../../bank/bank-details-client-create/bank-details-client-create.component'
import { PaymentMethodsClientCreateComponent } from '../../../payment/payment-client-create/payment-methods-client-create.component'
import { TaxDocumentClientCreateComponent } from '../../../tax-document/tax-document-client-create/tax-document-client-create.component'
import { ContactClientCreateComponent } from '../../../contact/contact-client-create/contact-client-create.component'
import { AddressClientCreateComponent } from '../../../address/address-client-create/address-client-create.component'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../../core/models/response.model'
import { cpfValidator } from '../../../../shared/utils/cpf_validator'
import { cnpjValidator } from '../../../../shared/utils/cnpj_validator'
import { SupplierService } from '../../../../core/services/person/supplier/supplier.service'
import { ResponsibleClientCreateComponent } from '../../responsible-client-create/responsible-client-create.component'
import { MatOption } from '@angular/material/core'
import { DocumentTypeService } from '../../../../core/services/document/document-type/document-type.service'
import { MatSelectModule } from '@angular/material/select'
import { DocumentUploadFormCreate } from '../../../document/document-upload-create/document-upload-form/document-upload-form.component'
import { CreateSupplierFormModel } from '../../../../core/models/supplier.model'
import { DocumentUploadCreateComponent } from '../../../document/document-upload-create/document-upload-create.component'

@Component({
  selector: 'supplier-create',
  imports: [
    ReactiveFormsModule,
    MatButton,
    MatProgressSpinner,
    MatExpansionModule,
    MatFormFieldModule,
    MatCardModule,
    MatIcon,
    MatInput,
    // MatOption,
    // MatSelect,
    MatDividerModule,
    AddressClientCreateComponent,
    ContactClientCreateComponent,
    TaxDocumentClientCreateComponent,
    PaymentMethodsClientCreateComponent,
    BankDetailsClientCreateComponent,
    // ConsultantClientCreateComponent,
    NgxMaskDirective,
    ResponsibleClientCreateComponent,
    MatButton,
    MatButtonModule,
    MatOption,
    MatSelectModule,
    DocumentUploadFormCreate,
    DocumentUploadCreateComponent,
  ],
  templateUrl: './supplier-create.component.html',
  styleUrl: './supplier-create.component.scss',
  providers: [SupplierService],
  standalone: true,
})
export class SupplierCreateComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private supplierService: SupplierService,
    private snackbar: SnackbarCustomService,
    private documentTypeService: DocumentTypeService,
    private dialogRef: MatDialogRef<SupplierCreateComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  @Output() responseCreate = new EventEmitter()
  @Output() responseModal = new EventEmitter()

  formLegalSupplier: FormGroup = new FormGroup({})
  formNaturalSupplier: FormGroup = new FormGroup({})
  // formFinancial: FormGroup = new FormGroup({})
  listTypeClient: any = [
    { id: 'legal', description: 'Jurídica' },
    // { id: 'natural', description: 'Fisica' },
  ]

  idFornecedor: any

  typeClient: 'legal' | 'natural' = 'legal'

  form: FormGroup = new FormGroup({})
  loading = false

  addressList: any[] = []
  contactList: any[] = []
  taxDocumentList: any[] = []
  paymentMethodsList: any[] = []
  bankDetailsList: any[] = []
  responsibleList: any[] = []
  documentList: any[] = []

  // consultantList: any[] = []
  // tariffList: any[] = []
  // subClientList: any[] = []

  panelAdress = false
  panelContact = false
  panelResponsable = false
  panelFinancial = false
  panelBankDetails = false
  panelDocument = false

  ngOnInit(): void {
    this.createForm()
  }

  close() {
    this.dialogRef.close()
  }

  createForm(): void {
    this.formLegalSupplier = this.formBuilder.group({
      name: ['', [Validators.required]],
      cnpj: ['', [Validators.required, cnpjValidator()]],
      corporate_name: ['', [Validators.required]],
      reg_state: [''],
      reg_municipal: [''],
    })
    this.formNaturalSupplier = this.formBuilder.group({
      name: ['', [Validators.required]],
      cpf: ['', [Validators.required, cpfValidator()]],
    })
    // this.form = this.formBuilder.group({

    // })
  }

  getList(
    list: any[],
    typeList:
      | 'address'
      | 'contact'
      | 'paymentMethod'
      | 'bankDetails'
      | 'responsible'
      | 'taxDocument'
      | 'document',
  ): void {
    switch (typeList) {
      case 'address':
        this.addressList = list
        break
      case 'contact':
        this.contactList = list
        break
      case 'bankDetails':
        this.bankDetailsList = list
        break
      case 'taxDocument':
        this.taxDocumentList = list
        break
      case 'paymentMethod':
        this.paymentMethodsList = list
        break
      case 'responsible':
        this.responsibleList = list
        break
      case 'document':
        this.documentList = list
        break
      // case 'consultant':
      //   this.consultantList = list
      //   break
      // case 'tariff':
      //   this.tariffList = list
      //   break
      // case 'subClient':
      //   this.subClientList = list
      //   break
    }
  }

  checkInvalidForm() {
    if (
      (this.typeClient == 'legal' && this.formLegalSupplier.invalid) ||
      (this.typeClient == 'natural' && this.formNaturalSupplier.invalid) ||
      this.loading ||
      this.addressList.length == 0 ||
      this.contactList.length == 0 ||
      this.taxDocumentList.length == 0 ||
      this.paymentMethodsList.length == 0 ||
      this.bankDetailsList.length == 0
      // this.consultantList.length == 0
      // this.tariffList.length == 0 ||
      // this.responsibleList.length == 0 ||
      // this.subClientList.length == 0
    ) {
      return true
    } else {
      return false
    }
  }

  createLegalModel() {
    const model = new CreateSupplierFormModel()

    model.fornecedor = {
      nome: this.formLegalSupplier.get('name')?.value ?? '',
      razao_social: this.formLegalSupplier.get('corporate_name')?.value ?? '',
      //  insc_municipal:
      //    this.formLegalSupplier.get('reg_municipal')?.value ?? '',
      //  insc_estadual: this.formLegalSupplier.get('reg_state')?.value ?? '',
      insc_municipal: this.formLegalSupplier.get('reg_municipal')?.value ?? '',
      insc_estadual: this.formLegalSupplier.get('reg_state')?.value ?? '',
      cnpj: this.formLegalSupplier.get('cnpj')?.value ?? '',
    }

    model.enderecos = this.addressList.map(
      ({ tipo_endereco, idCreate, ...remainder }) => remainder,
    )

    model.contatos = this.contactList.map(
      ({ tipoContato, idCreate, ...remainder }) => remainder,
    )

    model.documento_fiscal = this.taxDocumentList.map(
      (ele: any) => ele.tipo_documento_id,
    )
    model.forma_pagamento = this.paymentMethodsList.map(
      ({ tipo_pagamento, idCreate, ...remainder }) => remainder,
    )
    model.dados_bancarios = this.bankDetailsList.map(
      ({ bancoDesc, idCreate, ...remainder }) => remainder,
    )
    model.responsaveis = this.responsibleList.map(
      ({ idCreate, ...remainder }) => remainder,
    )

    if (this.documentList.length > 0) {
      model.files = this.documentList.map(
        ({ idCreate, ...remainder }) => remainder,
      )
    }

    return model.toFormData()
  }

  // uploadFile(event: any) {
  //   this.supplierService.uploadSupplierDocument(event).subscribe({
  //     next: (res) => {
  //       this.responseCreate.emit();
  //       this.form.reset();
  //     },
  //     error: (err) => {
  //       console.error(err)
  //     }
  //   })
  // }

  createIndividualModel() {
    return {
      fornecedor: {
        nome: this.formNaturalSupplier.get('name')?.value ?? '',
        cpf: this.formNaturalSupplier.get('cpf')?.value ?? '',
      },
      enderecos: this.addressList.map(
        ({ tipo_endereco, idCreate, ...remainder }) => remainder,
      ),
      contatos: this.contactList.map(
        ({ tipoContato, idCreate, ...remainder }) => remainder,
      ),
      documento_fiscal: this.taxDocumentList.map(
        (ele: any) => ele.tipo_documento_id,
      ),
      forma_pagamento: this.paymentMethodsList.map(
        ({ tipo_pagamento, idCreate, ...remainder }) => remainder,
      ),
      dados_bancarios: this.bankDetailsList.map(
        ({ bancoDesc, idCreate, ...remainder }) => remainder,
      ),
      // consultores: this.consultantList,
      // comissao: this.formFinancial.get('commission')?.value ?? '',
      // divisao: this.formFinancial.get('divider')?.value ?? '',
      // tarifarios: this.tariffList,
      // sub_clientes: this.subClientList,
    }
  }

  createSupplier() {
    this.loading = true
    if (this.typeClient == 'legal') {
      this.createSupplierLegal()
      this.responseModal.emit({ refresh: true, clear: true })
    } else if (this.typeClient == 'natural') {
      this.createSupplierNatural()
    } else {
      this.snackbar.error('Selecione um tipo de Cliente')
    }
  }

  createSupplierLegal() {
    this.supplierService
      .createSupplierLegal(this.createLegalModel())
      .subscribe({
        next: (response: ResponseRequestModel) => {
          this.snackbar.success(response.message)
          this.responseCreate.emit()
          this.idFornecedor = response.data.id
          this.close()
        },
        error: (err: ErrorRequestModel) => {
          this.loading = false
          this.snackbar.errorRequest(err)
        },
        complete: () => {
          this.loading = false
          this.formLegalSupplier.reset()
          this.formNaturalSupplier.reset()
        },
      })
  }

  createSupplierNatural() {
    this.supplierService
      .createSupplierNatural(this.createIndividualModel())
      .subscribe({
        next: (response: ResponseRequestModel) => {
          this.snackbar.success(response.message)
          this.responseCreate.emit()
          this.close()
        },
        error: (err: ErrorRequestModel) => {
          this.loading = false
          this.snackbar.errorRequest(err)
        },
        complete: () => {
          this.loading = false
          this.formLegalSupplier.reset()
          this.formNaturalSupplier.reset()
        },
      })
  }
}
